import { plainTextAtom } from 'features/generator/contentFormSections/PlainTextForm'
import { atom } from 'jotai'

import { QR_TYPE } from '../../generatorTypes'

export type TPlainTextContent = {
	type: QR_TYPE.PlainText
	text: string
}

export const plainTextContentAtom = atom<
	TPlainTextContent,
	[TPlainTextContent],
	void
>(
	(get) => ({
		type: QR_TYPE.PlainText,
		text: get(plainTextAtom),
	}),
	(_, set, content: TPlainTextContent) => {
		set(plainTextAtom, content.text)
	},
)
